import BlogPage from 'src/views/Marketing/Blog/components/BlogPage';
import Footer from 'src/views/Marketing/components/Footer';
import NavBar from 'src/views/Marketing/components/NavBar';
import { ScrollView, StyleSheet } from 'react-native';

export default function Page() {
  return (
    <ScrollView style={styles.scrollView}>
      <NavBar />
      <BlogPage
        author='Albert Chuang'
        dateTime='2021-10-17'
        tag='Poshmark'
        title='Reseller Assistant, Posh Sidekick, and Poshmark Pro Tools owned by same person?'
      >
        <p>
          <i>
            Due to legal exposure, our team is intentionally being careful here to share what we think the community
            should know while also focusing purely on the facts.
          </i>
        </p>
        <p>
          <i>
            Reseller Assistant is a popular virtual assistant service that has historically claimed to provide services
            without using bots for Poshmark. Poshmark Pro Tools is one of the earliest Poshmark automation services.
            Posh Sidekick appears to be a new spin-off brand launched by the owner of Poshmark Pro Tools.
          </i>
        </p>
        <p>
          If you look up both Reseller Assistant Inc (the legal entity for Reseller Assistant) and Poshmark Tools Inc
          (the legal entity for Poshmark Pro Tools and Posh Sidekick) in the public{' '}
          <a href='https://apps.dos.ny.gov/publicInquiry/EntityDisplay'>
            New York Department of State’s entity search tool
          </a>
          , you’ll find many details match exactly. This includes the process name (which is always one of the company
          owners or a trusted registered agent) and company address. The initial filing date is also only days apart.
        </p>
        <p>Why do these business registration filing details look so similar?</p>
        <p>Here is a screenshot of the results for Reseller Assistant Inc, taken on October 17th, 2021:</p>
        <figure>
          <img
            className='w-full rounded-lg'
            src='/static/images/blog/screenshots/reseller-assistant-2021-10-17.png'
            alt='Reseller Assistant Inc Entity'
            width={1310}
            height={1056}
          />
        </figure>
        <p>Here is a screenshot of the results for Poshmark Tools Inc, taken on October 17th, 2021:</p>
        <figure>
          <img
            className='w-full rounded-lg'
            src='/static/images/blog/screenshots/poshmark-tools-2021-10-17.png'
            alt='Poshmark Tools Inc Entity'
            width={1310}
            height={1056}
          />
        </figure>

        <p>
          <i>
            OneShop is not endorsed, certified, or affiliated by Poshmark, Poshmark Pro Tools, Reseller Assistant,
            Poshmark Tools, Poshmark Sidekick, Poshmark Sharer. The names Poshmark, Poshmark Pro Tools, Reseller
            Assistant, Poshmark Tools, Poshmark Sidekick, Poshmark Sharer are owned by their respective owners and are
            not owned by the owners of OneShop.
          </i>
        </p>
      </BlogPage>
      <Footer />
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  scrollView: {
    flex: 1,
  },
});
